import { Container } from 'unstated';
import { getPersistentStore, getPersistentStoreMutex } from '@lemonadefashion/storage';

const KEY = 'referral';
function _getStore() { return getPersistentStore(); }
function _getMutex() { return getPersistentStoreMutex(); }

function getReferralFromStore() {
  try {
    const infoJson = _getStore().getItem(KEY);
    if (infoJson == null) return null;
    return JSON.parse(infoJson);
  } catch (error) {
    console.log(error);
    return null;
  }
}

function updateReferralInStore(referral) {
  return new Promise((resolve, reject) => {
    const mutex = _getMutex();
    const store = _getStore();
    mutex.lock(KEY)
      .then(() => {
        store.setItem(KEY, JSON.stringify(referral));
        return mutex.release(KEY).then(resolve).catch(reject);
      })
      .catch(reject);
  });
}

class ReferralContainer extends Container {
  constructor() {
    super();
    this.state = {
      referral: getReferralFromStore()
    };
    window.addEventListener('storage', e => {
      if (e.key !== KEY) return;
      this.setState({ referral: getReferralFromStore() });
    });
  }

  get() { return this.state.referral; }

  set(referral) {
    return new Promise((resolve, reject) => {
      updateReferralInStore(referral)
        .catch(console.log)
        .finally(() => this.setState({ referral: referral }, resolve));
    });
  }
}

export default ReferralContainer;
